// extracted by mini-css-extract-plugin
export var resinTextContainer = "blogTitle-module--resinTextContainer--1hotc";
export var resinText = "blogTitle-module--resinText--1_XRa";
export var blogImage = "blogTitle-module--blogImage--1VVxj";
export var blogTitleText = "blogTitle-module--blogTitleText--2uAOp";
export var blogTitleContent = "blogTitle-module--blogTitleContent--2ARd1";